import React, { useState } from "react";
import { Button, Modal, ModalHeader, Form, FormGroup, Input } from "reactstrap";
import CharacterGroups from "../characters/CharacterGroups";
import { useStoreActions, useStoreState } from "easy-peasy";

export default function LocationSearchModal(props) {
  const [modal, setModal] = useState(false);
  const [locationName, setLocationName] = useState("");

  const search = useStoreActions(
    (actions) => actions.location.characterLocationData
  );
  const searchedLocations = useStoreState((state) => state.location.data);

  const handleSubmit = (evt) => {
    evt.preventDefault();
  };

  const searchLocations = () => {
    let payload = {
      name: locationName,
    };
    if (locationName.length > 1) {
      search(payload);
    }
  };

  const handleKeypress = (e) => {
    let payload = {
      name: locationName,
    };
    if (e.key === "Enter" && locationName.length > 1) {
      search(payload);
    }
  };

  return (
    <div>
      <Modal
        isOpen={props.modal}
        fade={false}
        toggle={props.toggle}
        className={props.className}
      >
        <div style={{ borderRadius: 60 }}>
          <Form
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              padding: 20,
              backgroundColor: "#1E1E22",
            }}
            onSubmit={handleSubmit}
          >
            <Input
              type="text"
              name="characterName"
              id="characterName"
              placeholder="Search Locations.. ( min 2 letters )"
              value={locationName}
              onKeyPress={handleKeypress}
              onChange={(e) => setLocationName(e.target.value)}
            />
            <Button
              style={{ marginLeft: 10 }}
              color="primary"
              onClick={searchLocations}
            >
              <span style={{ fontFamily: "Fredoka One" }}>Search</span>
            </Button>
          </Form>
          <div style={{ backgroundColor: "#1E1E22", padding: 20 }}>
            <CharacterGroups
              inputs="LOC"
              characternames={searchedLocations}
              maxHeight="390px"
              type="search"
              avatarsize={90}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
